import type { EmailTemplate, EmailTemplatePosition } from '@recruitee/email-templates-types';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<EmailTemplate>()(
  EntityStoreKey.EmailTemplatesGeneral,
  {
    idSelector: (entity: { id?: number | string | null }) => entity.id!,
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);

      return {
        updatePositions: (state, payload: EmailTemplatePosition[]) => adapter.markAsPending(state),
        updatePositionsSuccess: actions.updateOnePessimisticSuccess,
        updatePositionsFailed: actions.updateOnePessimisticFailed,
        duplicateTemplate: (state, payload: { id: number; correlationId: string }) =>
          actions.createOnePessimistic(state, {
            data: { id: payload.id },
            correlationId: payload.correlationId,
          }),
        duplicateTemplateSuccess: actions.createOnePessimisticSuccess,
        duplicateTemplateFailed: actions.createOnePessimisticFailed,
      };
    },
  },
);

export {
  actions as EmailTemplatesGeneralActions,
  selectors as EmailTemplatesGeneralSelectors,
  reducer as EmailTemplatesGeneralReducer,
  namespace as EmailTemplatesGeneralNamespace,
};
